/**
 * Функция определяет количество недель в месяце с учётом того,
 * что неделя начинается с понедельника.
 */
export const getNumberOfWeeksInMonth = (firstWeekDayOfMonth: number, monthDaysCount: number) => {
  return Math.ceil((firstWeekDayOfMonth + monthDaysCount) / 7);
};
